import { Pipe, PipeTransform } from '@angular/core';
import * as jalalimoment from "jalali-moment";
@Pipe({
  name: 'agoTime'
})
export class AgoTimePipe implements PipeTransform {

  transform(value: Date): string {
    if(!value)return "نامعلوم";
    let date = new Date(value);
    return jalalimoment(date).locale('fa').fromNow(false);
  }

}
